import React, { useEffect, useState } from "react";
import { Gift, Sparkles } from "lucide-react";
import { useApp } from "../AppContext";
import api from "../api";

const LoyaltyBadge = ({ phone }) => {
    const { t, lang } = useApp();
    const [data, setData] = useState(null);

    useEffect(() => {
        const digits = (phone || "").replace(/[^\d]/g, "");
        if (digits.length < 7) {
            setData(null);
            return;
        }
        const timer = setTimeout(() => {
            api.get(`/loyalty/${digits}`)
                .then((r) => setData(r.data))
                .catch(() => setData(null));
        }, 400);
        return () => clearTimeout(timer);
    }, [phone]);

    if (!data || data.order_count === 0) {
        return (
            <div
                data-testid="loyalty-badge"
                className="rounded-2xl border border-dashed border-terracotta-300 bg-terracotta-50 p-4 flex items-center gap-3"
            >
                <div className="w-10 h-10 rounded-full bg-terracotta-500 text-white flex items-center justify-center shrink-0">
                    <Gift className="w-5 h-5" />
                </div>
                <div className="text-sm text-earth-800">
                    <div className="font-bold">{t.loyalty.title}</div>
                    <div className="text-xs text-earth-600">{t.loyalty.firstOrder}</div>
                </div>
            </div>
        );
    }

    const progress = ((data.order_count % 10) / 10) * 100;
    const showReward = data.rewards_earned > 0 && data.order_count % 10 === 0;

    return (
        <div
            data-testid="loyalty-badge"
            className="rounded-2xl bg-gradient-to-br from-terracotta-500 to-[#CE1126] text-white p-4 shadow-md"
        >
            <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur flex items-center justify-center">
                    <Sparkles className="w-5 h-5" />
                </div>
                <div className="text-sm flex-1">
                    <div className="font-bold">{t.loyalty.title}</div>
                    {showReward ? (
                        <div className="text-xs">
                            {t.loyalty.earned} <b>{data.rewards_earned}</b> {t.loyalty.free}
                        </div>
                    ) : (
                        <div className="text-xs">
                            {t.loyalty.keepGoing}{" "}
                            <b>{data.orders_until_reward}</b> {t.loyalty.more}
                        </div>
                    )}
                </div>
                <div className="text-2xl font-serif font-black tabular-nums">
                    {data.order_count % 10}/10
                </div>
            </div>
            <div className="h-2 bg-white/20 rounded-full overflow-hidden">
                <div
                    className="h-full bg-white transition-all duration-700"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default LoyaltyBadge;
